import {StoreProductDefinition, StoreProductMapping} from "../../common/models/StoreProduct";
import {StripeProductName} from "../../../stripe/models/StripeProductNames";

export enum IInvestStoreProduct {
    PLATFORM = "PLATFORM"
}

const platform: StoreProductDefinition = {
    description: "Platform",
    trial: 30,
    stripeProducts: [StripeProductName.PLATFORM],
    coupon: null
};

export const IInvestProductMappings: StoreProductMapping<IInvestStoreProduct> = {
    PLATFORM: platform
};
